import {
  put, takeLatest, select, all, takeEvery,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import { peopleSchema, peopleListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/people/actions';
import { getCompetition } from 'app/ducks/competitions/actions';

import { PeopleActionTypes as types } from 'app/ducks/people/types';

function* createPersonSaga(action): any {
  yield put(sagaActions.createPersonPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).people.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, peopleSchema);

    yield put(sagaActions.createPersonSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPersonFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePersonSaga(action): any {
  yield put(sagaActions.updatePersonPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).people.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, peopleSchema);

    yield put(sagaActions.updatePersonSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePersonFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getPersonSaga(action): any {
  yield put(sagaActions.getPersonPending());
  const [error, response] = yield (yield TeammoApi(yield select())).people.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, peopleSchema);
    yield put(sagaActions.getPersonSuccess(normalizedResponse));
    const person = normalizedResponse.entities.people[normalizedResponse.result];
    if (!_.isEmpty(person.competition)) {
      yield put(yield getCompetition(person.competition.id));
    }
    return person;
  }
  yield put(
    handleError(error, sagaActions.getPersonFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllPeopleSaga(action): any {
  yield put(
    sagaActions.getAllPeoplePending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.people.pagination))
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).people.list(paginationObject);

  if (response) {
    const normalizedResponse = normalize(response, peopleListSchema);

    yield put(
      sagaActions.getAllPeopleSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPeopleFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPersonSagaWatcher(): any {
  yield takeLatest(types.CREATE_PERSON_REQUESTED, createPersonSaga);
}

function* updatePersonSagaWatcher(): any {
  yield takeLatest(types.UPDATE_PERSON_REQUESTED, updatePersonSaga);
}

function* getPersonSagaWatcher(): any {
  yield takeEvery(types.GET_PERSON_REQUESTED, getPersonSaga);
}

function* getAllPeopleSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_PEOPLE_REQUESTED, getAllPeopleSaga);
}

export default function* root(): any {
  yield all([
    createPersonSagaWatcher(),
    updatePersonSagaWatcher(),
    getPersonSagaWatcher(),
    getAllPeopleSagaWatcher(),
  ]);
}
